import React from "react"
import SEO from "../components/SEO"
import PolicyPage from "../features/policy"
import { WEBSITE } from "../constants"

const Policy: React.FC = () => {
  return (
    <>
      <SEO
        title={`Chính Sách`}
        description="Chính sách bảo mật, điều khoản sử dụng và các quy định của TuTiMi Tea. Cam kết bảo vệ thông tin khách hàng và cung cấp dịch vụ chất lượng cao."
        keywords="TuTiMi, chính sách, bảo mật, điều khoản, quy định, trà sữa, cà phê"
      />
      <PolicyPage />
    </>
  )
}

export default Policy
